import React, { useState } from 'react';

import { UiComponent } from 'components';
import Info from './Info';
import Participation from './Participation';
import Attendees from './Attendees';

const TABS = ['기본정보', '참여정보', '참석자'] as const;
type TabType = (typeof TABS)[number];

function MobileDetail() {
  const [activeTab, setActiveTab] = useState<TabType>('기본정보');

  return (
    <>
      <UiComponent.MobileTabs
        items={TABS}
        value={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === '기본정보' && <Info />}
      {activeTab === '참여정보' && <Participation />}
      {activeTab === '참석자' && <Attendees />}
    </>
  );
}

export default MobileDetail;
